import React from 'react'
import PropTypes from 'prop-types'

/**
 * Reusable RadioButton component matching Figma design using Bootstrap classes
 *
 * @param {Object} props - Component props
 * @param {string} props.name - Radio button group name
 * @param {string} props.id - Unique identifier for this radio button
 * @param {string} props.value - Value of this radio button
 * @param {boolean} props.checked - Whether this radio button is selected
 * @param {Function} props.onChange - Handler for change events
 * @param {string} props.label - Label text for the radio button
 * @param {boolean} props.disabled - Whether the radio button is disabled
 * @param {string} props.className - Additional CSS classes for the wrapper
 */
const RadioButton = ({
  name,
  id,
  value,
  checked,
  onChange,
  label,
  disabled = false,
  className = ''
}) => {
  // Using Bootstrap's custom-control structure for radio buttons
  const containerClasses = `custom-control custom-radio ${className}`

  return (
    <div className={containerClasses}>
      <input
        className="custom-control-input"
        type="radio"
        name={name}
        id={id}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <label
        className="custom-control-label"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  )
}

RadioButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]).isRequired
}

export default RadioButton